import type { MutableAppLink } from '@atlassian/jira-issue-view-common-types/src/issue-type.tsx';
import type { SelectItemAppLink } from './types.tsx';

export const transformAppLink = (item: MutableAppLink): SelectItemAppLink => ({
	label: `${item.name}`,
	value: item.id,
	fullObject: item,
});
